// extracted by mini-css-extract-plugin
module.exports = {"contentBlur":"companyInfo_contentBlur__fOH5p"};